'use client';

import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import styles from './scrollToTop.module.scss';
import analyticsEvents from 'static/analytics_events';
import { pushEvent } from '@repo/ui/src/services/analytics';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = (): void => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    pushEvent(analyticsEvents.scroll_to_top, {
      timestamp: new Date().toISOString(),
      button_text: 'Scroll to Top',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          role="button"
          aria-label="Scroll to the top"
          className={styles.scroll_to_top}
          onClick={scrollToTop}
        >
          <FaArrowUp />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
